import { KpisByPlanChartData } from '../../components/Dashboard/Chart/KpisByPlanChart/types';
import { DateRangeState } from '../../components/Dashboard/DateRangeControl/useDateRange';
import { RP_KPIS } from './constants';
import { DashboardAvgData, PlanPreviousDateRangeDatasetKey } from './types';

export const getPercentKpisByPlanType = ({
  kpiPlanType,
  data,
  planPreviousDateRange,
}: {
  data: DashboardAvgData;
  kpiPlanType: string;
  planPreviousDateRange: PlanPreviousDateRangeDatasetKey;
}) => {
  return Object.entries(data).reduce((acc, [field, value]) => {
    if (
      value &&
      'kpiType' in value &&
      value.kpiType.includes(kpiPlanType) &&
      typeof value.presentDateRange.value.raw.value === 'number' &&
      value.presentDateRange.value.raw.suffix === '%'
    ) {
      acc.push({
        field: field,
        value: value.presentDateRange.value.raw.value,
        prefix: value.presentDateRange.value.raw.prefix || '',
        suffix: value.presentDateRange.value.raw.suffix || '',
        rawValue: value.presentDateRange.value.raw.value,
        previous: value.previousDateRange.filteredDataset[planPreviousDateRange].raw.value,
        benchmarkMin: value.presentDateRange.benchmark.raw.min,
        benchmarkMax: value.presentDateRange.benchmark.raw.max,
      });
    }

    return acc;
  }, []);
};

export const getActualRpKpis = ({
  data,
  planPreviousDateRange,
}: {
  data: DashboardAvgData;
  planPreviousDateRange: PlanPreviousDateRangeDatasetKey;
}) => {
  const actualRpKpis: Array<KpisByPlanChartData> = [];

  RP_KPIS.map((kpi) => {
    const kpiData = data[kpi];

    if (kpiData) {
      actualRpKpis.push({
        field: kpi,
        value: kpiData.presentDateRange.value.raw.value,
        prefix: kpiData.presentDateRange.value.raw.prefix || '',
        suffix: kpiData.presentDateRange.value.raw.suffix || '',
        rawValue: kpiData.presentDateRange.value.raw.value,
        previous: kpiData.previousDateRange.filteredDataset[planPreviousDateRange].raw.value,
        benchmarkMin: kpiData.presentDateRange.benchmark.raw.min,
        benchmarkMax: kpiData.presentDateRange.benchmark.raw.max,
      });
    }
  });

  return actualRpKpis;
};

export const getPlanPreviousDateRangeCopy = (
  dateRange: DateRangeState,
  planPreviousDateRange: 'lastYear' | 'previousQuarter',
) => {
  if (planPreviousDateRange === 'lastYear') {
    return `CY${dateRange.year - 1}`;
  } else if (planPreviousDateRange === 'previousQuarter') {
    return dateRange.quarter === 1
      ? `CY${dateRange.year - 1} Q4`
      : `CY${dateRange.year} Q${dateRange.quarter - 1}`;
  }

  return '';
};
